<template>
  <b-row>
    <b-col
      xs="12"
      md="6"
    >
      <b-card title="Hoşgeldiniz">
        <p>Eurofiber - Online Tahsilat sistemine hoş geldiniz.</p>
        <p>Online tahsilat sistemi, banka kartı veya kredi kartınız ile güvenli ödeme işlemi yapabilirsiniz.</p>
        <b-button
          variant="primary"
          to="payment/customer-search"
        >
          <FeatherIcon icon="CreditCardIcon" />
          Ödeme Sayfasına Git
        </b-button>
      </b-card>
    </b-col>
    <b-col
      xs="12"
      md="6"
    >
      <b-card :title="companyData.title || 'İletişim Bilgileri'">
        <div
          v-if="companyData.tax_no || companyData.tax_office"
          class="font-medium-1 mb-1"
        >
          <span
            v-if="companyData.tax_no"
            class="font-weight-bold"
          >VN:</span>
          {{ companyData.tax_no }}
          <span
            v-if="companyData.tax_office"
            class="font-weight-bold"
          >VD:</span>
          {{ companyData.tax_office }}
        </div>
        <div
          v-if="companyData.address"
          class="font-medium-1 mb-1"
        >
          <FeatherIcon icon="MapPinIcon" />
          {{ companyData.address }}
        </div>
        <div
          v-if="companyData.phone"
          class="font-medium-1 mb-1"
        >
          <FeatherIcon icon="PhoneIcon" />
          +90{{ companyData.phone }}
        </div>
        <div
          v-if="companyData.fax"
          class="font-medium-1 mb-1"
        >
          <FeatherIcon icon="PrinterIcon" />
          +90{{ companyData.fax }}
        </div>
        <div
          v-if="companyData.email"
          class="font-medium-1 mb-1"
        >
          <FeatherIcon icon="MailIcon" />
          <a :href="'mailto:' + companyData.email">{{ companyData.email }}</a>
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow, BCol, BCard, BButton,
} from 'bootstrap-vue'

export default {
  name: 'DashboardIndex',
  components: {
    BRow,
    BCol,
    BCard,
    BButton,
  },
  computed: {
    companyData() {
      return this.$store.getters['company/getCompany']
    },
  },
  created() {
    this.$store.dispatch('company/companyView')
  },
}
</script>
